import PropTypes from "prop-types";
import ReportHeader from "./ReportHeader";
import { TR } from "./BusinessDashboard/Table/Table";

const AgentActivityHeaders = ({ sortBy, sortKey, sortDesc }) => (
  <TR className="tw-sticky tw-top-0 tw-bg-white">
    <ReportHeader name="agent" sortDesc={sortDesc} sortKey={sortKey} label="Name" handleSort={sortBy} />
    <ReportHeader
      name="lead_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Leads"
      className="tw-text-center"
      tooltipDesc="Contacts assigned to the agent during this date range, including contacts in ponds the agent is the display agent for. Excludes archived and trashed contacts and contacts without an email or phone number."
      handleSort={sortBy}
    />

    <ReportHeader
      name="email_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Emailed"
      className="tw-text-center"
      tooltipDesc="Unique contacts the agent emailed during this date range. Only counts contacts who were also assigned to the agent during this date range."
      handleSort={sortBy}
    />

    <ReportHeader
      name="call_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Called"
      className="tw-text-center"
      tooltipDesc="Total number of calls the agent made during this date range, both manual and dialer. Repeat calls to the same contact each count."
      handleSort={sortBy}
    />
    <ReportHeader
      name="contacted_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Contacted"
      className="tw-text-center"
      tooltipDesc="Number of calls during this date range with a 'Talked to lead' outcome. Repeat connected calls to the same contact each count."
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Texted"
      className="tw-text-center"
      tooltipDesc="Unique leads texted during this date range that are assigned to the agent or in a pond the agent owns"
      handleSort={sortBy}
    />
    <ReportHeader
      name="email_resp_time"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Email Resp. Time"
      className="tw-text-center"
      tooltipDesc="Average time between a contact being assigned to the agent and each email the agent sent them. Only includes contacts assigned during this date range."
      handleSort={sortBy}
    />
    <ReportHeader
      name="call_resp_time"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Call Resp. Time"
      className="tw-text-center"
      tooltipDesc="Average time between a contact being directly assigned to the agent and each call the agent made to them. Only includes contacts assigned during this date range; pond contacts are not included."
      handleSort={sortBy}
    />
    <ReportHeader
      name="text_resp_time"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Text Resp. Time"
      className="tw-text-center"
      tooltipDesc="Average time between a contact being assigned to the agent and each text the agent sent them. Only includes contacts assigned during this date range."
      handleSort={sortBy}
    />
    <ReportHeader
      name="login_count"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Logins"
      className="tw-text-center"
      tooltipDesc="Total number of times the agent has ever logged in. Not limited to this date range."
      handleSort={sortBy}
    />
    <ReportHeader
      name="last_login"
      sortDesc={sortDesc}
      sortKey={sortKey}
      label="Last Login"
      className="tw-text-center"
      handleSort={sortBy}
    />
  </TR>
);

AgentActivityHeaders.propTypes = {
  sortBy: PropTypes.func.isRequired,
  sortKey: PropTypes.string.isRequired,
  sortDesc: PropTypes.bool.isRequired,
};

export default AgentActivityHeaders;
